import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { GET_DOC_MENTION_LIST, GET_MY_MENTION_LIST, MENTION_ADD, MENTION_DEL, MENTION_READ_REPORT, } from './cgi-path';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { getFormDataWithParams, getGlobalPadId } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
var AtMessageRepository = /** @class */ (function () {
    // networkRequest 注入
    function AtMessageRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    // 获取文档的At人列表
    AtMessageRepository.prototype.getDocMentionList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = getFormDataWithParams({
                            globalPadId: this.globalPadId,
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        });
                        url = "".concat(GET_DOC_MENTION_LIST);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // 获取文档中的At我的列表
    AtMessageRepository.prototype.getMyMentionList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = getFormDataWithParams({
                            globalPadId: this.globalPadId,
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        });
                        url = "".concat(GET_MY_MENTION_LIST);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // 删除一个At人记录
    AtMessageRepository.prototype.deleteMention = function (mentions) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = getFormDataWithParams({
                            globalPadId: this.globalPadId,
                            mentions: JSON.stringify(mentions),
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        });
                        url = "".concat(MENTION_DEL);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // 添加一个At人记录
    AtMessageRepository.prototype.addMention = function (mentions, vfwebqq) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = getFormDataWithParams({
                            globalPadId: this.globalPadId,
                            mentions: JSON.stringify(mentions),
                            vfwebqq: vfwebqq,
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        });
                        url = "".concat(MENTION_ADD);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // 发请求标志所有本次 At我的信息 已读
    AtMessageRepository.prototype.mentionReadReport = function (mentions) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = getFormDataWithParams({
                            globalPadId: this.globalPadId,
                            mentions: JSON.stringify(mentions),
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        });
                        url = "".concat(MENTION_READ_REPORT);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Object.defineProperty(AtMessageRepository.prototype, "globalPadId", {
        get: function () {
            var localPadId = this.docMetaDomainService.docMetaEntity.padInfo.padId;
            var creatorDomainId = this.docMetaDomainService.docMetaEntity.padInfo.domainId;
            return getGlobalPadId(creatorDomainId, localPadId);
        },
        enumerable: false,
        configurable: true
    });
    AtMessageRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], AtMessageRepository);
    return AtMessageRepository;
}());
export { AtMessageRepository };
